module.exports = __webpack_public_path__ + "img/NBA_icon.46f4a6ed.svg";